"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import {
	Credenza,
	CredenzaClose,
	CredenzaContent,
	CredenzaFooter,
	CredenzaHeader,
	CredenzaTitle,
} from "@/components/ui/credenza";
import { Form } from "@/components/ui/form";
import { FormInput } from "@/components/ui/input";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { emitter, type ModalEventState } from "@/lib/emitter";
import {
	type EditWorkspaceSchema,
	editWorkspaceSchema,
} from "@/lib/schema/workspace";

/** Control the modal state for editing a workspace */
export function controlEditWorkspace(properties: ModalEventState) {
	emitter.emit("settings.workspace.edit", properties);
}

export function EditWorkspaceDialog() {
	const {
		workspaceName,
		workspaceId,
		updateWorkspaceInformation,
		isUpdatingWorkspaceInformation,
	} = useCurrentWorkspace();
	const [isOpen, setOpenState] = useState(false);

	const initialValues = {
		name: workspaceName,
		workspaceId,
	};

	const form = useForm<EditWorkspaceSchema>({
		defaultValues: initialValues,
		resolver: zodResolver(editWorkspaceSchema),
	});

	// Setup modal event listener
	useEffect(() => {
		emitter.on("settings.workspace.edit", ({ state }) => {
			setOpenState(state === "on");
		});

		return () => {
			emitter.off("settings.workspace.edit", () => {
				setOpenState(false);
			});
		};
	}, []);

	const handleSave = async (data: EditWorkspaceSchema) => {
		await updateWorkspaceInformation(data);
		form.reset(data);
	};

	return (
		<Credenza
			onOpenChange={(open) => {
				form.reset(initialValues);

				if (!open) {
					controlEditWorkspace({
						state: "off",
					});
				}
			}}
			open={isOpen}
		>
			<CredenzaContent>
				<CredenzaHeader>
					<CredenzaTitle>Edit Workspace</CredenzaTitle>
				</CredenzaHeader>
				<Form {...form}>
					<form
						className="px-4 sm:px-0"
						id="edit-workspace-form"
						onSubmit={form.handleSubmit(handleSave)}
					>
						<FormInput
							disabled={isUpdatingWorkspaceInformation}
							form={form}
							name="name"
							placeholder="Workspace Name"
						/>
					</form>
				</Form>
				<CredenzaFooter>
					<CredenzaClose asChild>
						<Button disabled={isUpdatingWorkspaceInformation} variant="outline">
							Cancel
						</Button>
					</CredenzaClose>
					<Button
						disabled={isUpdatingWorkspaceInformation}
						form="edit-workspace-form"
						type="submit"
					>
						{isUpdatingWorkspaceInformation ? "Saving..." : "Save"}
					</Button>
				</CredenzaFooter>
			</CredenzaContent>
		</Credenza>
	);
}
